import { Heading } from "@chakra-ui/react";
import { FunctionComponent } from "react";

type Props = {
  label: string;
};

export const SectionTitle: FunctionComponent<Props> = ({ label }) => {
  return (
    <Heading as={"h5"} color={"#0B0A0A"} fontSize={"18px"}>
      {label}
    </Heading>
  );
};
